export default __webpack_public_path__ + "static/media/service-input.063750eb.jpeg";